export class LeagueInfoData {
    constructor(leagueInfoData) {
        this.ID = leagueInfoData.ID;
        this.Name = leagueInfoData.Name;
        this.SortID = leagueInfoData.SortID;
        this.RankID = leagueInfoData.RankID;
        this.MasterEvents = leagueInfoData.MasterEvents;
        this.LiveMasterEvents = leagueInfoData.LiveMasterEvents;
        this.hasCombos = leagueInfoData.hasCombos;
        this.EventTypes = leagueInfoData.EventTypes;
        this.IsHot = leagueInfoData.IsHot;
        this.hasLiveEvents = leagueInfoData.hasLiveEvents;
        this.visible = leagueInfoData.visible;
        this.isExpanded = leagueInfoData.isExpanded;
        this.CountryID = leagueInfoData.CountryID;
        this.BranchID = leagueInfoData.BranchID;
        this.Code = leagueInfoData.Code;
        this.hasLiveStream = leagueInfoData.hasLiveStream;
        this.BranchName = leagueInfoData.BranchName;
        this.CountryCode = leagueInfoData.CountryCode;
        this.hasFastMarkets = leagueInfoData.hasFastMarkets;
        this.CountryTranslatedName = leagueInfoData.CountryTranslatedName;
        this.MasterLeagueID = leagueInfoData.MasterLeagueID;
        this.UrlCode = leagueInfoData.UrlCode;
        this.isUserCountry = leagueInfoData.isUserCountry;
        this.EventsCount = leagueInfoData.EventsCount;
        this.LeagueNameWithoutCountry = leagueInfoData.LeagueNameWithoutCountry;
    }
}
//# sourceMappingURL=LeagueInfoData.js.map